import style from "../blog.module.css";
import ExpandableText from "../TextoExpandible";
import React, { Suspense, lazy } from "react";
const InstagramEmbed = lazy(() =>
  import("react-social-media-embed").then((module) => ({
    default: module.InstagramEmbed,
  })),
);

const Semana57: React.FC = () => {
  const Notice1 = `
  Ivo Siljic Bilicic de origen colombo-croata, su trayectoria profesional la ha encaminado hacía el bienestar integral de la comunidad, promoviendo una atención en salud con enfoque humano, ético y de calidad, además de ser un facilitador de conocimientos como docente en el campo de la medicina.

Por eso, desde el movimiento #ElCambioEsConVos del @partidoalianzaverde le hacemos este reconocimiento a toda una vida de vocación de servicio y compromiso social, cualidades que dignifican la profesión médica y genera un impacto positivo en la comunidad caleña.
  `
  return (
    <section className={style.Noticia}>
      <div className={style.Instagram}>
        <Suspense
          fallback={<div className="loading-placeholder">Loading...</div>}
        >
          <InstagramEmbed
            url="https://www.instagram.com/p/DXrynfdiQeg/?igsh=MWRldmg5ZWh3Z3E1"
            width={328}
          />
        </Suspense>
      </div>
      <div className={style.Separador}></div>
      <div className={style.NoticeBox}>
        <h1 className={style.Tittle}>En el Concejocali exaltamos la importante obra del médico y doctor en Ciencias Biomédicas Ivo Siljic Bilicic 😁🌻</h1>
        <h5 className={style.Fecha}>Abril 28 del 2026</h5>
        <ExpandableText text={Notice1} limit={800} />
        <p className={style.reportero}>
          Oficina de Comunicaciones Concejal Rodrigo Salazar, Partido Alianza
          Verde 🌻{" "}
        </p>
      </div>
    </section>
  );
};

export default Semana57;
